import axios from 'axios';
import { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useLocation } from 'react-router-dom';
import { BASE_URL } from '../../insightConfig/insightConfig';
import Dashboardleft from '../DashboardLeft/Dashboardleft';
import Dashboradeffect from '../EffectonLoad/Dashboardeffect';
import CivilButton from '../ReusableComponent/CIVIL/CivilButton/CivilButton';
import "./dashboard.css";

function Dashborad() {
  const authtoken = localStorage.getItem('authtoken');
  const componentName = "dashboard";
  const civilheading = ""
  const [userData, setUserData] = useState([]);
  const [loadUserData, setLoadUserData] = useState(false);

  const alert = useAlert();
  const location = useLocation();
  console.log(location);
  const { moduleName } = location.state || {};
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/studentdashboard`)
        setUserData(response?.data?.data);
      } catch (error) {
        alert.show(error?.response.data.message)
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [loadUserData]);

  if (!userData || userData.length === 0) {
    return <div><Dashboradeffect /></div>;
  }
  const userDtails = userData[0] || []

  return (
    <>
      <div className='Dashboard-background'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-lg-3 col-md-12 col-sm-12 dashboardmain-left p-3'>
              <Dashboardleft authtoken={authtoken} userDtails={userDtails} setLoadUserData={setLoadUserData} loadUserData={loadUserData} />
            </div>
            <div className='col-lg-9 col-md-12 col-sm-12'>
              <CivilButton moduleName={moduleName} componentName={componentName} heading={civilheading} userDtails={userDtails} prePath={location?.state?.prePath} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Dashborad;
